
import { GridInputSelectionModel } from "@mui/x-data-grid";
import { atomFamily } from "recoil";

export const DataGridSelectionModel = atomFamily<GridInputSelectionModel | undefined, string>({
    key: 'state.DataGridSelectionModel',
    default: undefined,
});
